export default __webpack_public_path__ + "static/media/teradata.a8235b40.png";